/**
 * A price field as a number, or null when it does not hold one.
 *
 * `price_adult` and `price_child` are STRINGS in Storyblok, and at least one vaccine uses that to
 * state a RANGE rather than a price: pneumokocker is "490-1150", because which of the two vaccines
 * is given decides. `Number("490-1150")` is NaN, and NaN fails every `> 0` test — which is how a
 * 490 kr vaccine came to advertise itself as free on the price card.
 *
 * Null therefore means "not arithmetic": show it as the editor wrote it, and subtract no discount
 * from it, because there is no single number to subtract from.
 */
export const numericPrice = (value: string | undefined) => {
  const trimmed = value?.trim() ?? ""
  if (!trimmed) return null
  const parsed = Number(trimmed)
  return Number.isFinite(parsed) ? parsed : null
}
